/* eslint-disable max-lines */
import { campaign, bbva } from 'api';
import {
  lsSetOfferGuid,
  lsGetOfferGuid,
  lsGetClientConsents,
  lsRemoveClientConsents,
  lsRemoveAuthTokenBBVA
} from 'helpers/store';
import {
  OFFER_SET_CURRENT_STEP,
  OFFER_UPDATE,
  OFFER_CHECK_GUID,
  OFFER_STATE_PROCESS,
  OFFER_OPERATION_BY_GUID,
  OFFER_CAMPAIGN_BY_ID,
  OFFER_CAMPAIGN_BY_GUID,
  OFFER_UPDATE_FROM_GUID,
  OFFER_UPDATE_OPERATION,
  OFFER_CREATE_OPERATION,
  OFFER_CREATE_OPERATION_DATA,
  OFFER_DOCUMENTS_REQUIRED_BY_GUID,
  OFFER_UPDATE_DOCUMENTS_REQUIRED,
  OFFER_UPDATE_SIGN,
  OFFER_ELECTRONIC_SIGNATURE,
  OFFER_PATCH_OPERATION,
  OFFER_UPLOAD_STUDY_DOCUMENTATION,
  OFFER_REGISTER_SIGNATURE,
  PRECONTRACT_BY_GUID,
  PRECONTRACT_UPDATE,
  OFFER_COMPLETED_KO,
  OFFER_UPDATE_COMPLETED_KO,
  OFFER_UPDATE_IBAN_BBVA,
  OFFER_LEGAL_CONDITIONS,
  OFFER_COMPONENTS_BY_PARTNER_ID,
  PRECONTRACT_BY_CAMPAIGN_ID,
  OFFER_SET_GUID_URL,
  OFFER_STEP_MANAGER,
  OFFER_APPLIED_CONSENTS
} from 'store/actions/offer';
import { UPDATE_OPERATION_DATA, SET_OPERATION_PROPERTY } from 'store/actions/operation';
import { UI_UPDATE_FROM_OFFER, UI_SET_LOADER_TEXT } from 'store/actions/ui';
import { OFFER_STATUS, OFFER_COOKIE_TO_PAGE } from 'store/enums';

export default {
  [OFFER_CHECK_GUID]: ({ commit, dispatch }, guid) =>
    new Promise((resolve, reject) => {
      campaign.validateCookie(guid).then(
        resp => {
          if (resp.data && resp.data.desStatus.toString().toLowerCase() === '5b') {
            lsRemoveAuthTokenBBVA();
            dispatch(`offer/${OFFER_CAMPAIGN_BY_ID}`, null, {
              root: true
            }).then(
              () => {
                commit(`offer/${OFFER_SET_CURRENT_STEP}`, 0, {
                  root: true
                });
                dispatch(`ui/${UI_SET_LOADER_TEXT}`, null, {
                  root: true
                });
                /** The GUID '00000000-0000-0000-0000-000000000001' is the
                 * error 'Your operation is not possible'
                 */
                commit(`offer/${OFFER_SET_GUID_URL}`, null, {
                  root: true
                });
                lsSetOfferGuid('00000000-0000-0000-0000-000000000001');
                resolve({ routerName: 'step-4-ko' });
              },
              errOffer => reject(errOffer)
            );
          } else {
            dispatch(OFFER_UPDATE_FROM_GUID, {
              data: resp.data,
              guid,
              cookie: true
            })
              .then(res => resolve(res))
              .catch(() => reject());
          }
        },
        err => {
          commit('ERROR_OCCURRED', err, { root: true });
          reject();
        }
      );
    }),

  [OFFER_STATE_PROCESS]: ({ commit, dispatch, getters, rootGetters }) =>
    new Promise((resolve, reject) => {
      const guid = getters.getOfferField('guidURL');
      campaign
        .getStateProcess({
          id: guid,
          ...rootGetters['operation/getDataForOfferStateProcess']
        })
        .then(
          resp => {
            const { data } = resp;
            if (OFFER_STATUS.OK === data.idStatus) {
              dispatch(OFFER_UPDATE_FROM_GUID, { data, guid })
                .then(res => resolve(res))
                .catch(() => reject());
            } else {
              dispatch(OFFER_UPDATE_FROM_GUID, { data, guid })
                .then(res => resolve(res))
                .catch(() => reject());
            }
          },
          err => {
            commit('ERROR_OCCURRED', err, { root: true });
            reject();
          }
        );
    }),

  [OFFER_OPERATION_BY_GUID]: ({ rootState, commit, dispatch }, nameRoute, guid) =>
    new Promise((resolve, reject) => {
      if (rootState.operation.operationFromAPI) return resolve();
      campaign.operationByGUID(guid || lsGetOfferGuid()).then(
        resp => {
          commit(`operation/${UPDATE_OPERATION_DATA}`, resp.data, {
            root: true
          });
          commit(OFFER_UPDATE_OPERATION, resp.data);
          if (nameRoute !== OFFER_COOKIE_TO_PAGE['step-5-thanks'].routerName) {
            dispatch(PRECONTRACT_BY_GUID)
              .then(precontract => {
                commit(PRECONTRACT_UPDATE, precontract);
                resolve({ partnerId: resp.data.partnerId });
              })
              .catch(() => reject());
          }
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, { root: true });
          reject();
        }
      );
    }),

  [OFFER_CAMPAIGN_BY_ID]: ({ commit, getters }) =>
    new Promise((resolve, reject) => {
      campaign
        .campaignFront({
          id: getters.getOfferField('idOffer'),
          partnerid: getters.getOfferField('partnerId'),
          idc: getters.getOfferField('idc')
        })
        .then(
          resp => {
            const data = resp.data;
            const { theme, campaignDetail, partnerFooter } = data;
            commit(OFFER_UPDATE, data);
            commit(
              `ui/${UI_UPDATE_FROM_OFFER}`,
              {
                theme,
                logoFrontLeft: campaignDetail.logoFrontLeft,
                logoFrontRight: campaignDetail.logoFrontRight,
                footerLogos: partnerFooter.logos,
                footerPubli: partnerFooter.logoPubli,
                disclaimer: partnerFooter.disclaimer
              },
              { root: true }
            );
            resolve();
          },
          err => {
            commit('ERROR_OCCURRED', err, { root: true });
            reject();
          }
        );
    }),

  [OFFER_CAMPAIGN_BY_GUID]: ({ commit }, guid) =>
    new Promise((resolve, reject) => {
      campaign.campaignFrontByGuid(guid || lsGetOfferGuid()).then(
        resp => {
          const data = resp.data;
          const { theme, campaignDetail, partnerFooter } = data;
          commit(OFFER_UPDATE, data);
          commit(
            `ui/${UI_UPDATE_FROM_OFFER}`,
            {
              theme,
              logoFrontLeft: campaignDetail.logoFrontLeft,
              logoFrontRight: campaignDetail.logoFrontRight,
              footerLogos: partnerFooter.logos,
              footerPubli: partnerFooter.logoPubli,
              disclaimer: partnerFooter.disclaimer
            },
            { root: true }
          );
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, { root: true });
          reject();
        }
      );
    }),

  [OFFER_CREATE_OPERATION]: ({ rootState, commit, dispatch, getters }) =>
    new Promise((resolve, reject) => {
      commit(OFFER_CREATE_OPERATION_DATA, JSON.parse(JSON.stringify(rootState.operation)));
      dispatch(`ui/${UI_SET_LOADER_TEXT}`, 'Creando la operación', {
        root: true
      });
      campaign.createOperation(getters.getOfferField('createOperationData')).then(
        resp => {
          const { data } = resp;
          const consents = lsGetClientConsents();
          if (consents) {
            lsRemoveClientConsents();
            campaign.appliedConsents(data.guid, consents).then(
              () => {
                dispatch(OFFER_UPDATE_FROM_GUID, { data })
                  .then(res => resolve(res))
                  .catch(() => reject());
              },
              err => {
                commit('ERROR_OCCURRED', err, { root: true });
                reject();
              }
            );
          } else {
            dispatch(OFFER_UPDATE_FROM_GUID, { data })
              .then(res => resolve(res))
              .catch(() => reject());
          }
        },
        err => {
          const { status, data } = err.response;
          commit('ERROR_OCCURRED', err, { root: true });
          if (status === 409 && data && data.idStatus === 13 && data.guid) {
            dispatch(OFFER_UPDATE_FROM_GUID, {
              data: {
                idStatus: 200,
                desStatus: '6'
              },
              guid: data.guid
            })
              .then(res => resolve(res))
              .catch(() => reject());
          } else {
            reject();
          }
        }
      );
    }),

  [OFFER_DOCUMENTS_REQUIRED_BY_GUID]: ({ commit }, otherGuid) =>
    new Promise((resolve, reject) => {
      const guid = otherGuid || lsGetOfferGuid();
      campaign.documentsRequiredByGuid(guid).then(
        resp => {
          commit(OFFER_UPDATE_DOCUMENTS_REQUIRED, resp.data);
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, { root: true });
          reject();
        }
      );
    }),

  [OFFER_UPDATE_IBAN_BBVA]: ({ commit, dispatch, rootGetters }) =>
    new Promise((resolve, reject) => {
      bbva.accountDetails(rootGetters['bbva/getBBVADataField']('selectedAccountId')).then(
        respBBVA => {
          const { result, data } = respBBVA.data;
          if (result.code === 200) {
            const { formats } = data.account;
            commit(
              `operation/${SET_OPERATION_PROPERTY}`,
              { field: 'signRequest.bankAccount', value: formats.iban },
              {
                root: true
              }
            );
            dispatch(OFFER_UPDATE_SIGN)
              .then(() => resolve())
              .catch(() => reject());
          } else {
            commit('ERROR_OCCURRED', { message: result.info }, { root: true });
            reject();
          }
        },
        err => {
          commit('ERROR_OCCURRED', err, { root: true });
          reject();
        }
      );
    }),

  [OFFER_UPDATE_SIGN]: ({ rootState, commit, getters }) =>
    new Promise((resolve, reject) => {
      const { bankAccount, delivery, deliveryId } = rootState.operation.signRequest;
      commit(OFFER_UPDATE_SIGN, {
        guid: lsGetOfferGuid(),
        data: {
          bankAccount,
          deliveryId,
          province: delivery.provinceCode
        }
      });
      campaign.updateSign(getters.getOfferField('singRequestData')).then(
        resp => {
          const data = resp.data;
          if (OFFER_STATUS.OK === data.idStatus) {
            const cookieToPage = OFFER_COOKIE_TO_PAGE[data.desStatus.toString().toLowerCase()];
            commit(OFFER_SET_CURRENT_STEP, cookieToPage.step);
            resolve({ routerName: cookieToPage.routerName, url: data.url });
          } else {
            reject();
          }
        },
        err => {
          commit('ERROR_OCCURRED', err, { root: true });
          reject();
        }
      );
    }),

  [OFFER_ELECTRONIC_SIGNATURE]: ({ commit, getters }) =>
    new Promise((resolve, reject) => {
      const guid = lsGetOfferGuid();
      campaign
        .electronicSignature({
          Id: getters.getOfferField('idOperation'),
          gvGuid: guid
        })
        .then(
          resp => {
            const { data } = resp;
            if (OFFER_STATUS.OK === data.idStatus) {
              const cookieToPage = OFFER_COOKIE_TO_PAGE[data.desStatus.toString().toLowerCase()];
              commit(OFFER_SET_CURRENT_STEP, cookieToPage.step);
              resolve({ routerName: cookieToPage.routerName, url: data.url });
            } else {
              reject();
            }
          },
          err => {
            commit('ERROR_OCCURRED', err, { root: true });
            reject();
          }
        );
    }),

  [OFFER_APPLIED_CONSENTS]: ({ commit, dispatch }, consents) =>
    new Promise((resolve, reject) => {
      const guid = lsGetOfferGuid();
      if (consents) {
        campaign.appliedConsents(guid, consents).then(
          () => {
            dispatch(OFFER_ELECTRONIC_SIGNATURE)
              .then(res => resolve(res))
              .catch(() => reject());
          },
          err => {
            commit('ERROR_OCCURRED', err, { root: true });
            reject();
          }
        );
      } else {
        dispatch(OFFER_ELECTRONIC_SIGNATURE)
          .then(res => resolve(res))
          .catch(() => reject());
      }
    }),

  [OFFER_PATCH_OPERATION]: (params, { commit, data }) =>
    new Promise((resolve, reject) => {
      campaign
        .patchOperation({
          guid: lsGetOfferGuid(),
          operations: data
        })
        .then(
          resp => {
            if (OFFER_STATUS.OK === resp.data.idStatus) resolve();
            else reject();
          },
          err => {
            commit('ERROR_OCCURRED', err, { root: true });
            reject();
          }
        );
    }),

  [OFFER_STEP_MANAGER]: ({ commit }) =>
    new Promise((resolve, reject) => {
      campaign.stepManager(lsGetOfferGuid()).then(
        resp => {
          const { data } = resp;
          const cookieToPage = OFFER_COOKIE_TO_PAGE[data.desStatus];
          commit(OFFER_SET_CURRENT_STEP, cookieToPage.step);
          resolve({ routerName: cookieToPage.routerName });
        },
        err => {
          reject(err.response.data);
        }
      );
    }),

  [OFFER_UPLOAD_STUDY_DOCUMENTATION]: ({ commit }) =>
    new Promise((resolve, reject) => {
      campaign.uploadStudyDocumentation(lsGetOfferGuid()).then(
        resp => {
          if (OFFER_STATUS.OK === resp.data.idStatus) resolve(resp);
          else reject();
        },
        err => {
          commit('ERROR_OCCURRED', err, { root: true });
          reject();
        }
      );
    }),

  [OFFER_REGISTER_SIGNATURE]: ({ commit }, params) =>
    new Promise((resolve, reject) => {
      campaign.registerSignature(params).then(
        resp => {
          const data = resp.data;
          if (OFFER_STATUS.OK === data.idStatus) {
            commit(OFFER_REGISTER_SIGNATURE, data.url);
            resolve(data);
          } else {
            reject();
          }
        },
        err => {
          commit('ERROR_OCCURRED', err, { root: true });
          reject();
        }
      );
    }),

  [PRECONTRACT_BY_GUID]: ({ commit }, guid) =>
    new Promise((resolve, reject) => {
      campaign.precontractByGUID(guid || lsGetOfferGuid()).then(
        resp => {
          if (resp && resp.data) resolve(resp.data);
          else reject();
        },
        err => {
          commit('ERROR_OCCURRED', err, { root: true });
          reject();
        }
      );
    }),

  [PRECONTRACT_BY_CAMPAIGN_ID]: ({ commit, getters }, campaignId) =>
    new Promise((resolve, reject) => {
      campaign.precontractByCampaignId(campaignId || getters.getOfferField('idOffer')).then(
        resp => {
          const { data } = resp;
          if (data) {
            commit(PRECONTRACT_UPDATE, data);
            resolve();
          } else reject();
        },
        err => {
          commit('ERROR_OCCURRED', err, { root: true });
          reject();
        }
      );
    }),

  [OFFER_LEGAL_CONDITIONS]: ({ commit, getters }, step) =>
    new Promise((resolve, reject) => {
      campaign
        .legalConditions({
          idOffer: getters.getOfferField('idOffer'),
          step
        })
        .then(
          resp => {
            commit(OFFER_LEGAL_CONDITIONS, resp.data);
            resolve();
          },
          err => {
            commit('ERROR_OCCURRED', err, { root: true });
            reject();
          }
        );
    }),

  // The GUID '00000000-0000-0000-0000-000000000001' is the error 'Your operation is not possible'
  [OFFER_COMPLETED_KO]: ({ state, commit, getters }) =>
    new Promise((resolve, reject) => {
      if (!getters.hasOffer) resolve('404');
      campaign.errorKOByGUID(state.guidURL || lsGetOfferGuid()).then(
        resp => {
          if (resp && resp.data) {
            commit(OFFER_UPDATE_COMPLETED_KO, resp.data);
            resolve();
          } else reject();
        },
        err => {
          commit('ERROR_OCCURRED', err, { root: true });
          reject();
        }
      );
    }),

  [OFFER_COMPONENTS_BY_PARTNER_ID]: ({ commit, getters }, id) =>
    new Promise((resolve, reject) => {
      campaign.componentsByPartnerId(id, getters.getOfferField('partnerId')).then(
        resp => {
          commit(OFFER_COMPONENTS_BY_PARTNER_ID, resp.data);
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, { root: true });
          reject();
        }
      );
    })
};
